import utils from '@/utils';
import { clone } from '@/utils/dataUtil';
import { BILLING_REF_API } from '@/api';

const state = {
  tableKey: -999,
  currentTableRow: null,
  tableData: [],
  tableConfig: {
    columns: [{
      prop: 'id', label: 'ID', sortable: true, filterable: true, width: 75, alignment: 'center',
    }, {
      prop: 'accountName', label: 'Account Name', sortable: true, filterable: true, width: 150,
    }, {
      prop: 'accountNumber', label: 'Account Number', sortable: true, filterable: true, width: 100,
    }, {
      prop: 'name', label: 'Bank Name', sortable: true, filterable: true, width: 150,
    }, {
      prop: 'routingNumber', label: 'Wire ABA Routing Number', sortable: true, filterable: true,
    }, {
      prop: 'bankABA', label: 'ACH ABA Routing Number', sortable: true, filterable: true,
    }, {
      prop: 'swift', label: 'SWIFT', sortable: true, filterable: true,
    }, {
      prop: 'ref', label: 'REF', sortable: true, filterable: true,
    }, {
      prop: 'fullAddress', label: 'Address', sortable: true, filterable: true, visible: true, width: 450,
    }, {
      prop: 'createdInfo', label: 'Created By', sortable: true, filterable: true, width: 170,
    }, {
      prop: 'updatedInfo', label: 'Updated By', sortable: true, filterable: true, width: 170,
    }],
    options: {
      filterRow: true,
      filterHeader: true,
      exportExcel: true,
    },
  },
  nullTableRow: {
    id: -999,
    accountName: null,
    accountNumber: null,
    name: null,
    routingNumber: null,
    address1: null,
    address2: null,
    address3: null,
    address4: null,
    createdBy: null,
    createdDate: null,
    updatedBy: null,
    updatedDate: null,
  },
};

const actions = {
  initialize({ commit, dispatch, state }) {
    dispatch('loadTableData');
  },
  async loadTableData({ commit }) {
    try {
      const { data: { data } } = await BILLING_REF_API.get('/banks');
      commit('loadTableData', data);
    } catch (err) {
      console.log(err);
      this.$notify('Failed to Load Data', 'error');
    }
  },
  postRecord({ state }, Bank) {
    BILLING_REF_API.post('/banks', Bank).then(({ data }) => {
      state.tableData.push(data);
      this.$notify('Data Added', 'success');
    }).catch((err) => {
      this.$notify('Failed to Add Data', 'error');
    });
  },
  updateRecord({ dispatch, commit, state }, Bank) {
    BILLING_REF_API.put(`/banks/${Bank.id}`, Bank).then(({ data }) => {
      commit('updateRecord', data);
      this.$notify('Data Updated', 'success');
    }).catch((err) => {
      this.$notify('Failed to Update Data', 'error');
    });
  },
  deleteTableRow({ dispatch, commit, state }) {
    BILLING_REF_API.delete(`/banks/${state.currentTableRow.id}`).then(({ data }) => {
      commit('deleteTableRow');
      dispatch('currentTableRowChange', clone(state.nullTableRow));
      this.$notify('Data Removed', 'success');
    }).catch((err) => {
      this.$notify('Failed to Remove Data', 'error');
    });
  },
  currentTableRowChange({ commit }, currentTableRow) {
    commit('currentTableRowChange', currentTableRow);
  },
};

const mutations = {
  updateRecord(state, record) {
    const rowIndex = state.tableData.findIndex(({ id }) => id === record.id);
    state.tableData.splice(rowIndex, 1, record);
  },
  currentTableRowChange(state, currentRow) {
    state.currentTableRow = currentRow;
  },
  resetTable(state) {
    state.tableData = [];
    state.currentTableRow = clone(state.nullTableRow);
  },
  loadTableData(state, records) {
    state.tableData = records;
  },
  createTableRow(state) {
    const record = clone(state.nullTableRow);
    record.id = state.tableKey++;
    record.versionId = 1;
    record.createdBy = this.getters['auth/getProfile'].userName;
    record.createdDate = utils.date.getNow().utc().format();
    state.currentTableRow = record;
  },
  copyTableRow(state) {
    const record = clone(state.currentTableRow);
    record.id = state.tableKey++;
    record.versionId = 1;
    record.createdBy = this.getters['auth/getProfile'].userName;
    record.createdDate = utils.date.getNow().utc().format();
    state.currentTableRow = record;
  },

  deleteTableRow(state) {
    state.tableData = state.tableData.filter((record) => record.id !== state.currentTableRow.id);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};